import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useEconomicAreaData(queryParams: PropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'disruptionByArea',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
